/**
 * Public tooltip overlay. Short copy stays a tooltip; long or rich content
 * upgrades to a hover popover via InfoTip. Empty content renders the child
 * alone, so callers can pass conditional copy (`cond ? label : undefined`).
 */

import { InfoTip } from './InfoTip';
import type { TooltipProps } from './TooltipPrimitive';

export type { TooltipProps };

export function Tooltip(props: TooltipProps) {
  const { content } = props;
  if (content === null || content === undefined || content === false || content === '') {
    return props.children;
  }
  return <InfoTip mode="auto" {...props} />;
}
